interface Fields {
  evaluationDate: string
  name: string
  excelFile: {
    fileFormat: 'csv' | 'xlsl'
    fileContentInBase64: string
  }
  duplicateFrom?: number
  customer: string
  usersInvolved: string[]
}

export default function createOrDuplicateProject(
  {post}: any,
  fields: Fields,
): Promise<any> {
  return post(`/projects`, fields, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/projects/createOrDuplicateProject.tsx